import { Divider, Group, Modal, useMantineTheme } from '@mantine/core';
import { Button, Text } from '@repo/foundations';

interface DeleteReportModalProps {
	isOpen: boolean;
	onCancel: () => void;
	onConfirm: () => void;
}

export function DeleteReportModal({
	isOpen,
	onCancel,
	onConfirm,
}: DeleteReportModalProps) {
	const theme = useMantineTheme();

	return (
		<Modal opened={isOpen} onClose={onCancel} title="Delete Report?" size="md">
			<Text>This can’t be undone.</Text>
			<Divider mt="md" />
			<Group position="right" mt={theme.spacing.md}>
				<Button variant="default" onClick={onCancel}>
					Cancel
				</Button>
				<Button variant="primary" tone="critical" onClick={onConfirm}>
					Delete Report
				</Button>
			</Group>
		</Modal>
	);
}
